module.exports = __webpack_public_path__ + "4c42cf5d6f0ad8979c7011b9d850effd.pdf";